export default {
    defaultSuppliers(state) {
        return state.suppliers.slice(0,5);
    },
    defaultCustomers(state) {
        return state.customers.slice(0,5);
    },
}